import iLagoGrande1 from '../../../Media/Ruko Paramount/iLago Grande/iLago Grande (1).webp'
import iLagoGrande2 from '../../../Media/Ruko Paramount/iLago Grande/iLago Grande (2).webp'
import iLagoGrande3 from '../../../Media/Ruko Paramount/iLago Grande/iLago Grande (3).webp'
import iLagoGrande4 from '../../../Media/Ruko Paramount/iLago Grande/iLago Grande (4).webp'
import iLagoGrande5 from '../../../Media/Ruko Paramount/iLago Grande/iLago Grande (5).webp'

const iLagoGrandeimages =[
iLagoGrande1,iLagoGrande2,iLagoGrande3,iLagoGrande4,iLagoGrande5
]

export default iLagoGrandeimages;
